import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DropdownOption,
  DropdownSize,
  DropdownVariant,
  DropdownPlacement,
} from 'src/app/core/interfaces/ui/dropdown.interface';

@Component({
  selector: 'shared-dropdown-generic',
  templateUrl: './dropdown-generic.component.html',
})
export class DropdownGenericComponent {
  @Input() options: DropdownOption[] = [];
  @Input() buttonClass: string = 'btn btn-outline-success ';
  @Input() buttonText: string = 'words.actions';
  @Input() buttonIcon: string = 'fa fa-ellipsis-v';
  @Input() tooltipText: string = '';
  @Input() dropdownId: string = 'genericDropdown';
  @Input() disabled: boolean = false;
  @Input() size: DropdownSize = '';
  @Input() variant: DropdownVariant = 'secondary';
  @Input() placement: DropdownPlacement = 'bottom';

  @Output() optionSelected = new EventEmitter<any>();

  get buttonClasses(): string {
    let classes = this.buttonClass;
    if (this.size) {
      classes += ` btn-${this.size}`;
    }
    return classes;
  }

  onOptionClick(option: DropdownOption): void {
    if (!option.disabled) {
      this.optionSelected.emit(option.value);
    }
  }
}
